<template>
  <div class="d-icon-processing-bar-flex">
    <svg version="1.1" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="0" width="32%" height="100%" ry="50%" :fill="customColor.grey">
        <animate
          attributeName="fill"
          dur="3s"
          :values="customColor.animation"
          repeatCount="indefinite"
          begin="0"
        ></animate>
      </rect>
      <rect x="34%" y="0" width="32%" height="100%" ry="50%" :fill="customColor.grey">
        <animate
          attributeName="fill"
          dur="3s"
          :values="customColor.animation"
          repeatCount="indefinite"
          begin="0.5"
        ></animate>
      </rect>
      <rect x="68%" y="0" width="32%" height="100%" ry="50%" :fill="customColor.grey">
        <animate
          attributeName="fill"
          dur="3s"
          :values="customColor.animation"
          repeatCount="indefinite"
          begin="1"
        ></animate>
      </rect>
    </svg>
  </div>
</template>

<script>
export default {
  name: "DIconProcessingBarFlex",
  props: {
    height: {
      type: String,
      default: "8px",
    },
    width: {
      type: String,
      default: "240px",
    },
    light: {
      type: Boolean,
      default: false,
    },
    customGrey: {
      type: String,
      default: "#17181a",
    },
  },
  computed: {
    customColor() {
      const mainBlue = "#4689f3";
      const mainGrey = this.light ? "#b6b6b6" : this.customGrey;
      return {
        grey: mainGrey,
        animation: [mainGrey, mainGrey, mainGrey, mainBlue, mainBlue, mainBlue].join(";"),
      };
    },
  },
};
</script>
<style scoped>
.d-icon-processing-bar-flex {
  position: relative;
}
</style>
